<template>
    <div class="loginWrap_form">
        <div class="loginWrap_form_top">
            <div class="loginWrap_hidden_logo">
                <a :href="$page.props.home_url ?? '/'">
                    <IconLogo />
                </a>
            </div>
            <a class="loginWrap_buttonBack" :href="$page.props.home_url ?? '/'">
                <IconArrowBack />
                <span>Back to the home page</span>
            </a>
            <div class="loginWrap_contentFade">
                <div class="loginWrap_success">
                    <div class="loginWrap_success_icon">
                        <IconSmsNotification />
                    </div>
                    <h1>Password reset link has been sent!</h1>
                    <p>To continue logging in, follow the link in your email!</p>

                    <div class="submitButton">
                        <Link href="/login">
                            <span>continue</span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import MainLayout from '@/layouts/MainLayout.vue';
import SideLayout from '@/layouts/SideLayout.vue';

export default {
    layout: [MainLayout, SideLayout],
};
</script>

<script setup lang="ts">
import { Link } from '@inertiajs/vue2';
import IconLogo from '@/components/icons/IconLogo.vue';
import IconArrowBack from '@/components/icons/IconArrowBack.vue';
import IconSmsNotification from '@/components/icons/IconSmsNotification.vue';
</script>

<style lang="scss">
.loginWrap {
  &_contentFade {
    position: relative;
  }

  &_success {
    padding: 44px 0;
    text-align: center;
    background-color: #ffffff;

    @media screen and (max-width: 1540px) {
      padding: 38px 0;
    }

    &_icon {
      width: 110px;
      height: 110px;
      background-color: #f5f4f8;
      border-radius: 50%;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;

      @media screen and (max-width: 1540px) {
        width: 80px;
        height: 80px;
      }

      &:before {
        content: "";
        position: absolute;
        width: 78px;
        height: 78px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: #38317f;
        border-radius: 50%;
        @media screen and (max-width: 1540px) {
          width: 56px;
          height: 56px;
        }
      }
      svg {
        position: relative;
        z-index: 2;
        width: 24px;
        height: 24px;
      }
    }

    h1 {
      @media screen and (max-width: 1100px) {
        max-width: 280px;
        margin: 0 auto;
      }
    }

    p {
      color: #4a4b4b;
      font-family: "ITC Avant Garde Gothic Std";
      font-size: 16px;
      font-style: normal;
      font-weight: 300;
      line-height: 175%;
      margin-bottom: 11px;

      @media screen and (max-width: 1540px) {
        font-size: 12px;
        margin-bottom: 8px;
      }
    }
  }
}

.fadeOut-leave-active{
  height: 370px;
  opacity: 1;
  transition: all 1s;
}

.fadeOut-leave-to{
  height: 0;
  opacity: 0;
}

.fadeIn-enter-active{
  height: 0;
  opacity: 0;
  transition: all 1s;
}
.fadeIn-enter-to{
  opacity: 1;
  height: 605px;
}

</style>
